import i18n from 'i18next';
import {FormattedFormField, TaskFormField} from '../../../../../types';
import {TaskField} from '../../../../../../../constants/tasks';
import {OptionsProp} from '../../../../../../../constants/types';
import {parseJSON} from '../../../../../../../helpers';

const formatSelectOptions = (
    options: Dictionary<string> = {}
): OptionsProp[] => {
  return Object.entries(options).map(([optionValue, optionLabelCode]) => {
    const label = i18n.t([`tasks:selectCodes.${optionLabelCode}`, optionLabelCode]);

    return {
      value: optionValue,
      label
    };
  });
};

const formatDetails = (type: TaskField, details: Nullable<string>) => {
  const parsedDetails = parseJSON(details);

  if (!parsedDetails) {
    return null;
  }

  if (type === TaskField.SELECT || type === TaskField.MULTI_SELECT) {
    const {options, default: defaultValue} = parsedDetails || {};

    if (!options) {
      return parsedDetails;
    }

    const newOptions = formatSelectOptions(options);

    return {
      default: defaultValue,
      options: newOptions
    };
  }

  return parsedDetails;
};

export const formatFormFields = (
    formFields: TaskFormField[]
): FormattedFormField[] => {
  return formFields?.map(({
    details, type, ...field
  }) => ({
    ...field,
    type,
    details: formatDetails(type, details)
  }));
};
